module.exports = __webpack_public_path__ + "static/media/Daniel.869030f7.JPG";